<template>
  <div>
    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :noDelete="true"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :getQry="getQry"
      :onDataReceived="onDataReceived"
      :showMore="true"
      tableName="reminders"
      :noVueChange="true"
      :calToolBarControls="calToolBarControls"
      :calendarFilter="calendarFilter"
      v-if="calReady"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
import TakePhoto from "../components/TakePhoto.vue";

export default {
  name: "OnsiteEstimates",
  components: {
    VCalTblMap: () => import("../components/CalTblMap.vue")
  },
  props: {},
  data() {
    return {
      allReminders: false,
      dateField: "date",
      calToolBarControls: [],
      defaultEventColor: "#137C15FF",
      // data_object: null,

      link: {
        field: "shipment_id",
        name: "shipment"
      },
      calReady: false,
      d: null,
      curUser: "",
      originalData: []
    };
  },
  mounted() {
    this.$root.$on("comboUpdated", c => {
      // console.log(c);
      if (c.ctlName == "curUser") {
        this.filterUsers(c);
      }
    });
    this.getDataObject();

    this.curUser = {
      full_name: this.$root.store.userData.first_name + " " + this.$root.store.userData.last_name,
      contact: { email: this.$root.user_email }
    };
    this.allReminders = this.$root.store.permittedActions.some(a => {
      return a.can_view_all_reminders;
    });
    this.calToolBarControls = [
      {
        comp: "v-combo",
        id: "curUser",
        hidden: !this.allReminders,

        show: this.allReminders,

        "v-bind": {
          ctlName: "curUser",
          vModel: this.curUser,
          label: "Select User",
          objName: "employee",
          qry: { category: "office_employee" },
          itemText: "contact.email",
          itemValue: "contact.email"
        }
      }
    ];
    this.calReady = true;
  },
  beforeDestroy() {},
  methods: {
    getQry() {
      if (!this.allReminders) {
        return {
          $or: [
            {
              user: this.$root.user_email
            },
            { "addressed_to.email": this.$root.user_email }
          ]
        };
      } else {
        return {};
      }
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },
    calendarFilter(cal, tableData) {
      var that = this;
      var curUserEmail = "";
      if (typeof this.curUser == "string") {
        curUserEmail = this.curUser;
      } else {
        curUserEmail = that.curUser?.contact?.email;
      }
      if (tableData) {
        tableData = this.originalData.model.filter(e => {
          var r = e.reminder;
          return (
            (r.user && r.user == curUserEmail) ||
            r.user?.email == curUserEmail ||
            (r.address_to &&
              r.addressed_to.some(a => {
                return a.email == that.curUser?.contact?.email || a.email == that.curUser;
              }))
          );
        });
        return tableData;
      }
      if (that.curUser && cal?.originalEvents) {
        var curEvents = cal.originalEvents.filter(e => {
          var r = e.reminder;
          return (
            (r.user && r.user == curUserEmail) ||
            r.user?.email == curUserEmail ||
            (r.address_to &&
              r.addressed_to.some(a => {
                return a.email == that.curUser?.contact?.email || a.email == that.curUser;
              }))
          );
        });
        return curEvents;
      } else {
        return cal?.originalEvents || [];
      }
    },
    filterUsers(c) {
      var that = this;
      if (!c && !that.curUser) {
        return;
      }
      if (c) {
        that.curUser = c.model;
      }
      // this.$nextTick(() => {

      var calTblMap = this.$refs.calTblMap;
      var cal = calTblMap.$refs.calendar;
      if (cal) {
        var tableData = that.$refs.calTblMap.tableData;
        cal.events = this.calendarFilter(cal);
        if (calTblMap.activeTab) {
          // filter in table mode
          calTblMap.dayClick(calTblMap.calModel, true, tableData);
        }

        // tableData = this.calendarFilter(cal);
        // that.$refs.calTblMap.tableData = tableData;
        // var tableKey = that.$refs.calTblMap.tableKey;
        // tableKey = !tableKey;
      }
      // });
    },
    eventTemplate: function(e, data, obj) {
      var endTime = new Date(e.reminder_date).addHours(1);
      var ev = {
        name: e.description + " " + e.shipment_id + " " + e.contact.first_name + " " + e.contact.last_name,

        start: new Date(e.reminder_date),
        end: endTime,
        shipment_id: e.shipment_id,
        first_name: e.contact.first_name,
        last_name: e.contact.last_name,
        description: e.description,
        timed: true,
        reminder: e.reminder
      };

      return ev;
    },
    reload() {
      //
    },
    getDataObject() {
      var data_object = {
        object_name: "v_reminder",
        date_fields: ["date"],
        mobileBreakpoint: 0,
        table_title: "Reminders",
        tableName: "Reminders",
        hasSearch: true,
        qry: {}
      };

      data_object.qry = this.getQry();

      return data_object;
    },

    eventClick(e) {
      this.linkClick(e.event);
    },
    onDataReceived(data, d, showTable) {
      this.originalData = fun.clone(data);
      this.filterUsers();

      return data;
    }
  }
};
</script>

<style lang="css" scoped></style>
